var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPageLeftDis(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u5DE6\u7BAD\u5934-dis@4x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u4E2A\\u4EBA\\u4E2D\\u5FC3-\\u8BA2\\u5355",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5207\\u56FE",
    transform: "translate(-594.000000, -3248.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5DE6\\u7BAD\\u5934-dis",
    transform: "translate(594.000000, 3248.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#0D47A0",
    opacity: 0.2,
    x: 0,
    y: 0,
    width: 20,
    height: 20,
    rx: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.17911376,8.0681561 C7.9372186,7.8199807 7.94032344,7.42411376 8.18849884,7.17911376 C8.43667425,6.9372186 8.83254118,6.94032344 9.07761175,7.18849884 L11.9051319,10.0694363 C12.1439222,10.3145069 12.1439222,10.704023 11.9051319,10.9490936 L9.18127102,13.7231964 C8.93937586,13.9713718 8.54040409,13.9745472 8.29222868,13.7325815 C8.04405328,13.4906158 8.04087788,13.0917146 8.28594844,12.8435392 L10.5761904,10.509265 L8.17911376,8.0681561 Z",
    id: "\\u8DEF\\u5F84",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    transform: "translate(10.042112, 10.455861) scale(-1, 1) translate(-10.042112, -10.455861) "
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPageLeftDis);
export default __webpack_public_path__ + "static/media/icon_page_left_dis.3ecf4bec8e636ed594d7a3b94dca3433.svg";
export { ForwardRef as ReactComponent };